import { compose } from 'recompose';
import apiInterceptor from '../../../../api/interceptor';
import AbbreviateInvoiceDetail from './AbbreviateInvoiceDetail';
import { salesInvoiceApi } from '../../../common/base.api';

const composedSalesInvoiceDetail = compose(apiInterceptor({ ...salesInvoiceApi }))(AbbreviateInvoiceDetail);

export default composedSalesInvoiceDetail;
